import React, { useEffect, useState } from 'react';

import { track } from '@betterment/js-runtime';
import { Icon, Text } from '@betterment/samba-react';
import { Box, Button, CenteredWorkflowLayout, Heading } from '@betterment/style-closet-react';

import Footer from '../Shared/components/Footer';
import { locationAssign } from '../Shared/path-helpers';
import { urlBuilder } from '../Shared/urlBuilder';

const InvitationCanceled: React.FC<React.PropsWithChildren<unknown>> = () => {
  useEffect(() => {
    track('ElementViewed', { name: 'InviteCanceled', flow: 'OpenJointCheckingSecondary' });
  }, []);

  const [isSubmitting, setSubmitting] = useState(false);

  const onAck = () => {
    setSubmitting(true);
    track('ElementClicked', { name: 'GotIt', flow: 'OpenJointCheckingSecondary' });
    locationAssign(urlBuilder.appHome.absolute());
  };

  return (
    <CenteredWorkflowLayout title="Joint Checking signup">
      <CenteredWorkflowLayout.Slot name="content">
        <Box mb="8">
          <Icon name="ExclamationCircle" size="large" color="icon" />
        </Box>
        <Heading as="h1" variant="primary">
          Your Joint Checking invite was canceled
        </Heading>
        <Box mb="9">
          <Text as="p">If this seems like a mistake, please contact our support team.</Text>
        </Box>
        <CenteredWorkflowLayout.Actions>
          <Button type="button" px="8" onClick={onAck} disabled={isSubmitting}>
            Got it
          </Button>
        </CenteredWorkflowLayout.Actions>
      </CenteredWorkflowLayout.Slot>
      <CenteredWorkflowLayout.Slot name="footer">
        <Footer />
      </CenteredWorkflowLayout.Slot>
    </CenteredWorkflowLayout>
  );
};

export default InvitationCanceled;
